<!--
  Base view of the bank account overview OBC (TM-1000002030). Never rendered: it only carries the navigation
  items that the full and the side view inherit, and each of those has its own template. The guarded block
  stays empty on purpose.

  @ticket TM-1000002030
-->
@if (initialized && dto) {
}
